import { Account } from './account';

import { randNumber, randCompanyName, randCatchPhrase } from '@ngneat/falso';

import { optional } from '@library/common/functions';

export class MockAccount extends Account {
   constructor() {
      const line_item_max = randNumber({ max: 99999 });
      const total_max = randNumber({ min: line_item_max, max: 99999 });

      const prefs = optional() ? null : { line_item_max, total_max };

      super({
         name: randCompanyName(),
         message: optional() ? randCatchPhrase() : '',
         prefs,
         invoices: [],
      });

      if ( optional( 30 )) { this.override = randNumber({ max: 10 }); }
   }
}
